export const ArrayMax = (array: Array<number>): number => {
    var max = Number.MIN_VALUE;
    for (let i = 0; i < array.length; i++)
        max = Math.max(max, array[i]);
    return max;
}

export const ArraySum = (array: Array<number>): number => {
    var ret = 0
    for (let i = 0; i < array.length; i++)
        ret += array[i];
    return ret;

}

export const ArrayMean = (array: Array<number>): number => {
    return ArraySum(array) / array.length;
}


export const GetRandomArray = (n: number, start: number = 0, step: number = 1, sample: number = -1): number[] => {

    const n2 = sample < 0 ? n : sample;

    const source = Array<number>();
    for (let i = 0; i < n; i++) {
        source.push(i * step + start);
    }

    const ret = Array<number>();

    for (let i = 0; i < n2; i++) {
        const index = Math.floor(Math.random() * source.length);
        const v = source[index];
        source.splice(index, 1);
        ret.push(v);
    }

    return ret;
}

export const GetSparseRandomArray = (n: number, sample: number, start: number = 0, step: number = 1): Array<number> => {

    const low = Math.floor(start / step);
    const high = low + n;
    const ret = Array<number>();
    for (let i = 0; i < sample; i++) {
        const v = GetRandomNumberNotInArray(low, high, ret);
    }

    if (step > 1) {
        for (let i = 0; i < ret.length; i++)
            ret[i] *= step;
    }
    return ret;
}

export const GetIntelligentRandomArray = (n: number, sample: number, start: number = 0, step: number = 1): number[] => {

    if (n > (0.5 * sample * sample))
        return GetSparseRandomArray(n, sample, start, step);
    else
        return GetRandomArray(n, start, step, sample);
}

export const GetRandomNumberNotInArray = (low: number, high: number, arr: Array<number>): number => {
    var success = false;
    const range = high - low;
    var value = -1;
    while (!success) {
        value = Math.floor(Math.random() * range) + low;
        var found = false;
        for (let i = 0; i < arr.length; i++) {
            if (value === arr[i]) {
                found = true;
                i = arr.length;
            }
        }
        if (!found) {
            success = true;
        }
    }
    return value;
}

export const DistributeArrayRandomly = (target: Array<number>, source: Array<number>, availableIndices: Array<number>) => {
    source.forEach((n) => {
        if (availableIndices.length > 0) {
            const ii = Math.floor(Math.random() * availableIndices.length);
            const index = availableIndices[ii];
            availableIndices.splice(ii, 1);

            target[index] = n;
        }
    })
}



export const GetBandedRandomArray = (n: number[], sample: number[], start: number = 0) : number[] => {
    const ret = Array<number>();
    if (n.length !== sample.length || n.length < 1)
        return ret;
    const availableIndices = Array<number>();
    for (let i = 0; i < sample[sample.length - 1]; i++) {
        ret.push(-1);
        availableIndices.push(i);
    }

    var prevSafeN = 0;

    for (let band = 0; band < (n.length - 1); band++) {
        const s0 = band === 0 ? 0 : n[band - 1];
        const bn = n[band] - prevSafeN;
        const bs = sample[band] - s0;
        const safeN = Math.max(bs, bn);

        const rand = GetIntelligentRandomArray(safeN, bs, prevSafeN + start);
        DistributeArrayRandomly(ret, rand, availableIndices);

        prevSafeN = safeN;
    }

    const penSample = sample.length > 1 ? sample[sample.length - 2] : 0;
    const maxN = Math.max(n[n.length - 1], prevSafeN + sample[sample.length - 1] - penSample);
    

    for (let i = 0; i < ret.length; i++) {
        if (ret[i] < start) {
            const rand = GetRandomNumberNotInArray(prevSafeN + start, maxN + start, ret);
            ret[i] = rand;
        }
    }

    return ret;

}